import * as React from 'react';

import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { AngularContext } from '../../../ts/factories/AngularContextFactory';

const template = `<tb:login-site-picker />`;

export function SitePickerProvider(props: {angularContext: AngularContext}): JSX.Element {
  return (
    <div>
      <AngularDirective
        angularContext={props.angularContext}
        template={template}
      />
    </div>
  );
}
